// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_e503da', '__Inter_Fallback_e503da'","fontStyle":"normal"},"className":"__className_e503da","variable":"__variable_e503da"};